import { createIcon } from '@jbhi-fi/lanyard-ui/components/Icon';
import React from 'react';

export const RedFlagIcon = createIcon({
  viewBox: '0 0 94 83',
  path: (
    <g fill="none">
      <path fill="red" stroke="#000" d="m89.317.534 4.058 58.028-43.399 23.466L4.592 64.773.534 6.743 89.317.532Z" />
    </g>
  ),
});
